const resource = '/v1/applications/categories';

export default $axios => ({
  index() {
    return $axios.get(`${resource}`);
  }
});
